exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host{\n  width:100%;\n}\n.netting-full-exposure{\n  display: table;\n  float:right;\n}\n.netting-full-exposure-inner{\n  display: table-cell;\n  font-size:15px;\n  font-weight:normal;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/wiserisk-core/src/main/ng4app/src/app/pages/rules/netting/netting.component.css
// module id = ../../../../../src/app/pages/rules/netting/netting.component.css
// module chunks = main